const handleMobileScroll = ({
  currentScrollY,
  lastScrollY,
  windowHeight,
  documentHeight,
  adClosed,
  setShowPrimaryHeader,
  setShowSecondaryHeader,
  setShowAdBanner,
  setShowStickyNavbar,
  showPrimaryHeader,
  showSecondaryHeader,
  showAdBanner,
  showStickyNavbar
}) => {
  const scrollDifference = currentScrollY - lastScrollY;
  const scrollThreshold = 20; // Increased threshold to reduce CLS and improve stability
  const navbarScrollThreshold = 0; // Zero threshold for navbar

  // Only determine direction if scroll difference exceeds threshold
  let direction = null;
  if (Math.abs(scrollDifference) > scrollThreshold) {
    direction = scrollDifference > 0 ? "down" : "up";
  } else if (Math.abs(scrollDifference) > navbarScrollThreshold) {
    // Navbar can update with zero threshold
    direction = scrollDifference > 0 ? "down" : "up";
  } else {
    // If scroll difference is too small, maintain previous state
    return null;
  }

  const isAtTop = currentScrollY < 50;
  const isAtBottom = (currentScrollY + windowHeight) >= (documentHeight - 100);

  // Determine desired state
  let desiredState = {
    primary: showPrimaryHeader,
    secondary: showSecondaryHeader,
    banner: showAdBanner,
    navbar: showStickyNavbar
  };

  if (isAtTop) {
    desiredState = { primary: true, secondary: true, banner: false, navbar: false };
  } else if (isAtBottom) {
    desiredState = { primary: true, secondary: true, banner: !adClosed, navbar: true };
  } else if (direction === "down") {
    desiredState = { primary: false, secondary: true, banner: !adClosed, navbar: false };
  } else if (direction === "up") {
    desiredState = { primary: false, secondary: true, banner: !adClosed, navbar: true };
  }

  // Only update state if it's different from current state
  if (desiredState.primary !== showPrimaryHeader) {
    setShowPrimaryHeader(desiredState.primary);
  }
  if (desiredState.secondary !== showSecondaryHeader) {
    setShowSecondaryHeader(desiredState.secondary);
  }
  if (desiredState.banner !== showAdBanner) {
    setShowAdBanner(desiredState.banner);
  }
  if (desiredState.navbar !== showStickyNavbar) {
    setShowStickyNavbar(desiredState.navbar);
  }

  return direction;
};

const handleDesktopScroll = ({
  currentScrollY,
  lastScrollY,
  windowHeight,
  documentHeight,
  setShowDesktopSecondaryHeader,
  setShowStickyNavbar,
  showDesktopSecondaryHeader,
  showStickyNavbar
}) => {
  const scrollDifference = currentScrollY - lastScrollY;
  const scrollThreshold = 20; // Increased threshold to reduce CLS and improve stability

  // Only determine direction if scroll difference exceeds threshold
  let direction = null;
  if (Math.abs(scrollDifference) > scrollThreshold) {
    direction = scrollDifference > 0 ? "down" : "up";
  } else {
    // If scroll difference is too small, maintain previous state
    return null;
  }

  const isAtTop = currentScrollY < 50;
  const isAtBottom = (currentScrollY + windowHeight) >= (documentHeight - 100);

  let desiredSecondaryHeader = showDesktopSecondaryHeader;
  if (isAtTop || isAtBottom) {
    desiredSecondaryHeader = true;
  } else if (direction === "down") {
    desiredSecondaryHeader = false;
  } else if (direction === "up") {
    desiredSecondaryHeader = true;
  }

  let desiredNavbar = currentScrollY > 100;

  // Only update if state changed
  if (desiredSecondaryHeader !== showDesktopSecondaryHeader) {
    setShowDesktopSecondaryHeader(desiredSecondaryHeader);
  }
  if (desiredNavbar !== showStickyNavbar) {
    setShowStickyNavbar(desiredNavbar);
  }

  return direction;
};

export const createScrollHandler = ({
  lastScrollY,
  makeSecondaryApiCalls,
  adClosed,
  setMakeSecondaryApiCalls,
  setShowPrimaryHeader,
  setShowSecondaryHeader,
  setShowAdBanner,
  setShowStickyNavbar,
  setShowDesktopSecondaryHeader,
  setScrollDirection,
  setLastScrollY,
  showPrimaryHeader,
  showSecondaryHeader,
  showAdBanner,
  showStickyNavbar,
  showDesktopSecondaryHeader
}) => {
  return () => {
    if (typeof window !== "undefined") {
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isMobileView = window.innerWidth < 769;

      if (currentScrollY > 700) {
        !makeSecondaryApiCalls && setMakeSecondaryApiCalls(true);
      }

      let direction;
      if (isMobileView) {
        direction = handleMobileScroll({
          currentScrollY,
          lastScrollY,
          windowHeight,
          documentHeight,
          adClosed,
          setShowPrimaryHeader,
          setShowSecondaryHeader,
          setShowAdBanner,
          setShowStickyNavbar,
          showPrimaryHeader,
          showSecondaryHeader,
          showAdBanner,
          showStickyNavbar
        });
      } else {
        direction = handleDesktopScroll({
          currentScrollY,
          lastScrollY,
          windowHeight,
          documentHeight,
          setShowDesktopSecondaryHeader,
          setShowStickyNavbar,
          showDesktopSecondaryHeader,
          showStickyNavbar
        });
      }

      // Only update state if direction changed (i.e., not null)
      if (direction !== null) {
        setScrollDirection(direction);
        setLastScrollY(currentScrollY);
      }
    }
  };
};
